import { gql } from '@apollo/client';

export const GET_QUIZ_RESPONSE = gql`
    query getQuizResponse($input: GetQuizResponseInput!) {
        getQuizResponse(input: $input) {
            id
            questionsInfo {
                id
                required
                nextQuestion {
                    choiceId
                    questionId
                }
            }
            startQuestion
            questions
            answers
            title
            subTitle
            help {
                title
                text
                url
                template
            }
        }
    }
`;

export const GET_PENDING_QUIZZES_RESPONSE = gql`
    query getPendingQuizzes {
        getPendingQuizzes {
            quizConfigs {
                quizId
                conditionQuiz
                status
            }
        }
    }
`;

export const GET_QUESTION_DATA = gql`
    query getQuestionData($input: GetQuestionDataInput!) {
        getQuestionData(input: $input) {
            data {
                id
                subject
                title
                descriptions
                value
                type
                imageUrl
                default
                enabled
                displayOrder
                tags
                localizationTitles {
                    currency
                    title
                }
                localizationTitle
            }
            paging {
                size
                page
            }
        }
    }
`;

export const GET_REQUEST_QUIZZES = gql`
    query getRequestQuizzes {
        getRequestQuizzes {
            quizConfigs {
                quizId
                order
                status
                genders
            }
        }
    }
`;
